/**
 * Vuex 模块 (Module) - 用于全局管理“比赛届数”
 *
 * 1. 在 App.vue 的 created() 钩子中,
 * 调用 this.$store.dispatch('match/fetchMatchVersionList') 来加载数据。
 * 2. 在任何需要下拉框的页面, 使用 mapGetters 和 computed 属性 v-model="matchVersion"
 */

import { $activity } from "@/services";

const state = {
  list: [], // 届数列表 (e.g., [{ dictLabel: '第四届', dictValue: '4' }, ...])
  current: null, // 当前选中的届数 (e.g., '4')
  // [新增] 存储默认届数的值
  defaultVersion: null,
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_CURRENT(state, version) {
    state.current = version;
  },
  // [新增] 设置默认届数
  SET_DEFAULT_VERSION(state, version) {
    state.defaultVersion = version;
  },
};

const actions = {
  // 获取届数列表 Action
  async fetchMatchVersionList({ commit, state }, preselectedVersion = null) {
    // 防止重复加载
    if (state.list.length > 0 && !preselectedVersion) {
      // 如果列表已存在且没有预选值，确保当前值有效
      if (!state.current && state.defaultVersion) {
        commit("SET_CURRENT", state.defaultVersion);
      }
      return;
    }

    try {
      const response = await $activity.getMatchVersion();
      if (response.success && response.data) {
        commit("SET_LIST", response.data);

        // 查找默认项
        const defaultItem = response.data.find(
          (item) => item.isDefault === "1"
        );
        const defaultVersionValue = defaultItem ? defaultItem.dictValue : null;
        // [修改] 存储默认值
        commit("SET_DEFAULT_VERSION", defaultVersionValue);

        // 设置当前选中项: 优先使用 preselectedVersion, 其次是当前 state.current, 最后是默认值
        if (
          preselectedVersion &&
          response.data.some((item) => item.dictValue === preselectedVersion)
        ) {
          commit("SET_CURRENT", preselectedVersion);
        } else if (!state.current && defaultVersionValue) {
          // 如果 state.current 尚未设置, 使用默认值
          commit("SET_CURRENT", defaultVersionValue);
        }
        // 如果 preselectedVersion 无效且 state.current 已有值, 则保持不变
      }
    } catch (error) {
      console.error("获取比赛届数列表失败:", error);
    }
  },

  // 更新当前选中届数 Action
  updateMatchVersion({ commit }, version) {
    commit("SET_CURRENT", version);
  },
};

const getters = {
  matchVersionList: (state) => state.list,
  currentMatchVersion: (state) => state.current,
  // [新增] 获取默认届数的值
  defaultMatchVersion: (state) => state.defaultVersion,
};

export default {
  namespaced: true, // 确保模块是命名空间的
  state,
  mutations,
  actions,
  getters,
};
